/* eslint-disable linebreak-style */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */
/* eslint-disable max-len */

import React from 'react';
import { Fade } from 'react-awesome-reveal';
import { useLanguage } from '../contexts/LanguageContext';

export default function ProductTestimonials({ data }) {
  const { t } = useLanguage();
  
  // Split testimonials into two rows
  const firstRow = data.slice(0, Math.ceil(data.length / 2));
  const secondRow = data.slice(Math.ceil(data.length / 2));

  // Duplicate data for infinite scroll effect - more copies for smoother scrolling
  const duplicatedFirstRow = [...firstRow, ...firstRow, ...firstRow, ...firstRow, ...firstRow];
  const duplicatedSecondRow = [...secondRow, ...secondRow, ...secondRow, ...secondRow, ...secondRow];

  return (
    <>
      <style>{`
        @keyframes scroll-left {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-100%);
          }
        }

        @keyframes scroll-right {
          0% {
            transform: translateX(-100%);
          }
          100% {
            transform: translateX(0);
          }
        }

        .animate-scroll-left {
          animation: scroll-left 60s linear infinite;
        }

        .animate-scroll-right {
          animation: scroll-right 60s linear infinite;
        }

        .line-clamp-4 {
          display: -webkit-box;
          -webkit-line-clamp: 4;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        /* Pause animation on hover */
        .animate-scroll-left:hover,
        .animate-scroll-right:hover {
          animation-play-state: paused;
        }
      `}</style>
      
      <section className="py-16 overflow-hidden">
        <div className="container mx-auto px-4 mb-12">
          <Fade direction="up">
            <h2 className="text-4xl lg:text-5xl text-white text-center font-bold mb-4">
              {t('testimonialTitle')}
            </h2>
          </Fade>
          <Fade direction="up" delay={300}>
            <p className="font-medium text-lg text-white text-center mb-8">
              {t('testimonialSubtitle')}
            </p>
          </Fade>
        </div>

        {/* First Row - Left to Right */}
        <div className="mb-8 w-full">
          <div className="flex animate-scroll-left gap-6 w-max">
            {duplicatedFirstRow.map((item, index) => {
              const cycleNum = Math.floor(index / firstRow.length);
              const posInCycle = index % firstRow.length;
              
              // Get translation keys based on item id
              let nameKey = '';
              let companyKey = '';
              let textKey = '';
              
              if (item.id === 1) {
                nameKey = 'testimonial1Name';
                companyKey = 'testimonial1Company';
                textKey = 'testimonial1Text';
              } else if (item.id === 2) {
                nameKey = 'testimonial2Name';
                companyKey = 'testimonial2Company';
                textKey = 'testimonial2Text';
              } else if (item.id === 3) {
                nameKey = 'testimonial3Name';
                companyKey = 'testimonial3Company';
                textKey = 'testimonial3Text';
              }
              
              return (
                <div
                  key={`first-${item.id}-cycle${cycleNum}-pos${posInCycle}`}
                  className="flex-shrink-0 w-80 bg-white/90 backdrop-blur-sm rounded-xl 
                           shadow-lg p-6 mx-2 hover:shadow-xl transition-shadow duration-300"
                >
                  <div className="flex items-center mb-4">
                    <img 
                      src={item.imageUrl} 
                      alt={t(nameKey)}
                      className="w-16 h-16 rounded-full object-cover border-2 border-green-600" 
                    />
                    <div className="ml-4">
                      <h3 className="text-lg font-bold text-gray-800">{t(nameKey)}</h3>
                      <p className="text-sm font-medium text-green-700">{t(companyKey)}</p>
                    </div>
                  </div>
                  <p className="text-gray-700 text-sm leading-relaxed line-clamp-4">
                    &ldquo;{t(textKey)}&rdquo;
                  </p>
                  <div className="flex mt-3">
                    <svg
                      className="w-4 h-4 text-yellow-400 fill-current"
                      viewBox="0 0 20 20"
                    >
                      <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
                    </svg>
                    <svg
                      className="w-4 h-4 text-yellow-400 fill-current"
                      viewBox="0 0 20 20"
                    >
                      <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
                    </svg>
                    <svg
                      className="w-4 h-4 text-yellow-400 fill-current"
                      viewBox="0 0 20 20"
                    >
                      <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
                    </svg>
                    <svg
                      className="w-4 h-4 text-yellow-400 fill-current"
                      viewBox="0 0 20 20"
                    >
                      <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
                    </svg>
                    <svg
                      className="w-4 h-4 text-yellow-400 fill-current"
                      viewBox="0 0 20 20"
                    >
                      <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
                    </svg>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Second Row - Right to Left */}
        <div className="w-full">
          <div className="flex animate-scroll-right gap-6 w-max">
            {duplicatedSecondRow.map((item, index) => {
              const cycleNum = Math.floor(index / secondRow.length);
              const posInCycle = index % secondRow.length;
              
              // Get translation keys based on item id
              let nameKey = '';
              let companyKey = '';
              let textKey = '';
              
              if (item.id === 1) {
                nameKey = 'testimonial1Name';
                companyKey = 'testimonial1Company';
                textKey = 'testimonial1Text';
              } else if (item.id === 2) {
                nameKey = 'testimonial2Name';
                companyKey = 'testimonial2Company';
                textKey = 'testimonial2Text';
              } else if (item.id === 3) {
                nameKey = 'testimonial3Name';
                companyKey = 'testimonial3Company';
                textKey = 'testimonial3Text';
              }
              
              return (
                <div
                  key={`second-${item.id}-cycle${cycleNum}-pos${posInCycle}`}
                  className="flex-shrink-0 w-80 bg-white/90 backdrop-blur-sm rounded-xl 
                           shadow-lg p-6 mx-2 hover:shadow-xl transition-shadow duration-300"
                >
                  <div className="flex items-center mb-4">
                    <img 
                      src={item.imageUrl} 
                      alt={t(nameKey)}
                      className="w-16 h-16 rounded-full object-cover border-2 border-green-600" 
                    />
                    <div className="ml-4">
                      <h3 className="text-lg font-bold text-gray-800">{t(nameKey)}</h3>
                      <p className="text-sm font-medium text-green-700">{t(companyKey)}</p>
                    </div>
                  </div>
                  <p className="text-gray-700 text-sm leading-relaxed line-clamp-4">
                    &ldquo;{t(textKey)}&rdquo;
                  </p>
                  <div className="flex mt-3">
                    <svg
                      className="w-4 h-4 text-yellow-400 fill-current"
                      viewBox="0 0 20 20"
                    >
                      <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
                    </svg>
                    <svg
                      className="w-4 h-4 text-yellow-400 fill-current"
                      viewBox="0 0 20 20"
                    >
                      <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
                    </svg>
                    <svg
                      className="w-4 h-4 text-yellow-400 fill-current"
                      viewBox="0 0 20 20"
                    >
                      <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
                    </svg>
                    <svg
                      className="w-4 h-4 text-yellow-400 fill-current"
                      viewBox="0 0 20 20"
                    >
                      <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
                    </svg>
                    <svg
                      className="w-4 h-4 text-yellow-400 fill-current"
                      viewBox="0 0 20 20"
                    >
                      <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
                    </svg>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
}
